export default __webpack_public_path__ + "static/media/exam.d43ef5fb.gif";